<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            <div class="mb-20 d-flex ">
                <el-button type="primary" @click="handleAddFooterBranche" class="ml-auto">
                    <!-- <font-awesome-icon :icon="['fas', 'user-plus']" style="width:20px" class="color-brown" /> -->
                    <span class="color-white">
                        add branche
                    </span>
                </el-button>
            </div>
            <el-card class="box-card">
                <el-table :data="footerBranches" style="width: 100%">
                    
                    
                     <el-table-column label="title En">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>

                   
                    <el-table-column label="description En" >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').description}}
                        </template>
                    </el-table-column>

                    <el-table-column label="title Ar" align="right" >
                        <template #default="scope">
                           <div class="">
                               {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                           </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="description Ar"  >
                        <template #default="scope">
                           <div class="rtl text-right">
                               {{$getLocaleData(scope.row.translates,'ar_sa').description}}
                           </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Operations" width="100">
                        <template #default="scope">
                            <el-popconfirm 
                                title="Are you sure to delete this?"
                                @confirm="deleteFooterBranche(scope.row)"
                            >
                                <template #reference>
                                   <font-awesome-icon :icon="['fas', 'trash']" style="width:20px" class="cursor-pointer color-red" />
                                </template>
                            </el-popconfirm>
                            
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
export default {
    computed:{
        cachedFooterBranches(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.footer?.footerBranches?.list || []
        },
    },
    data(){
        return{
            footerBranches:[],
            footerBrancheStatus:[],
           
        }
    },
    async mounted(){
        if (!this.cachedFooterBranches?.length){
            this.getAllFooterBranches();
        }else{
            this.footerBranches = this.cachedFooterBranches;
          
        }
        
       
    },
    
    methods:{
       
        async getAllFooterBranches(){
            const response = await this.$store.dispatch('getAllFooterBranches');

            this.footerBranches = response;
             
        },
        
      
        async handleAddFooterBranche(){
            this.$router.push({
                name:'manage-footer-branche'
            })
        },
        async deleteFooterBranche(footerBrancheData){
            
            let dataToSend = {
                id:footerBrancheData.id
            }
            const response = await this.$store.dispatch('deleteFooterBranche',dataToSend);
            if (response.data.status == 1){
                this.getAllFooterBranches();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                })
            }
            
        },
      
    
       
        
    }
}
</script>
<style lang="scss">
    .text-right.rtl {
        .cell {
            text-align: right;
            direction: rtl;
        }
    }
</style>